import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

export default function FluidImage({ data, alt = '', ...props }) {
    return <GatsbyImage {...props} image={data} alt={alt} backgroundColor="rgba(0, 0, 0, 0.1)" />
}
